import { Component, OnInit } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { Observable } from 'rxjs';

import { DesignationStateModel } from '../transaction-store/designation';
import { DonationActions, Donation } from '../transaction-store/donation';
import { AppSettings } from '../app.settings';
import { GaClient } from '../../init';

@Component({
  selector: 'app-donation-amount',
  template: `
    <section *ngIf="(designations$ | async).items.length < 2">
      <div class="container">
        <h2 class="section-title">How much do you want to donate?</h2>
      </div>
      <div class="container">
        <p class="has-error" *ngIf="showAmountError">
          Amount must be between
          {{ min | currency: currencyCode:'symbol-narrow' }} and
          {{ max | currency: currencyCode:'symbol-narrow' }}
        </p>
      </div>
      <div class="container">
        <div class="input-group box-group gift-amounts form-group">
          <label
            class="gift-amount"
            *ngFor="let item of amountMap; let i = index"
            for="donation-amount-{{ i }}"
            [ngClass]="
              item.value == selected ? 'btn-primary' : 'btn-outline-secondary'
            "
            tabindex="0"
            (keypress)="setSelected($event, item)"
          >
            <span class="block label-text small-label min-label">{{
              item.text
            }}</span>
            <span class="label">{{
              item.value | currency: currencyCode:'symbol-narrow':'1.2-2'
            }}</span>
            <input
              type="radio"
              name="donation-amount"
              [value]="item.value"
              id="donation-amount-{{ i }}"
              hidden
              [(ngModel)]="selected"
              (ngModelChange)="onChange($event)"
              [attr.aria-label]="'Donation amount ' + item.value"
            />
          </label>
          <div
            (click)="setCustomDonate(custom)"
            *ngIf="showCustom"
            class="gift-amount floating-label-form-group"
            [ngClass]="
              'custom' === selected ? 'btn-primary' : 'btn-outline-secondary'
            "
          >
            <input
              type="radio"
              name="donation-amount"
              value="custom"
              id="donation-amount-7"
              hidden
              [(ngModel)]="selected"
              (ngModelChange)="onChange($event)"
              [attr.aria-label]="'Donation amount ' + custom"
            />
            <currency-field
              [(ngModel)]="custom"
              [currencyCode]="currencyCode"
              (ngModelChange)="onChange($event)"
              [min]="min"
              [max]="max"
              label="$ Custom Amount"
              [isCustomAmount]=true
            ></currency-field>
          </div>
        </div>
      </div>
    </section>
  `
})
export class DonationAmountComponent implements OnInit {
  selected = '25';
  custom = 0;
  amountMap = [];
  min: number;
  max: number;
  showCustom = true;
  showAmountError = false;
  currencyCode = 'USD';
  @Select() designations$: Observable<DesignationStateModel>;
  @Select() donation$: Observable<Donation>;

  constructor(private store: Store, private settings: AppSettings) {
    this.currencyCode = this.settings.getValue('organization').currency_code;
    this.min = this.settings.getValue('minimumAmount');
    this.max = this.settings.getValue('maximumAmount');
    const properties = this.settings.getValue('properties');
    const giftAmounts = properties.gift_arrays || properties.gift_amounts;
    this.showCustom =
      properties.show_custom_amount == undefined
        ? true
        : properties.show_custom_amount;
    if (giftAmounts) {
      for (const amount of giftAmounts) {
        this.amountMap.push({ text: amount[0] || '', value: parseFloat(amount[1]) });
      }
    }
    const defaultAmount = parseFloat(properties.cash_default);
    this.selected = `${defaultAmount}`;

    if (
      this.amountMap.filter(amount => amount.value === defaultAmount).length ===
      0
    ) {
      this.custom = defaultAmount;
      this.selected = 'custom';
    }

    // override custom amount if passed as property
    if (properties.custom_gift_amount) {
      this.custom = Number(properties.custom_gift_amount);
    }

    this.donation$.subscribe(state => {
      const amount = state.amount;
      if (!amount) {
        return;
      }
      for (const mapItem of this.amountMap) {
        if (amount === +mapItem.value) {
          this.selected = mapItem.value;
        }
      }
      if (+this.selected !== amount) {
        this.selected = 'custom';
        this.custom = amount;
      }
    });
  }

  ngOnInit() {
    this.store.dispatch(
      new DonationActions.SetDonationAmount(
        this.selected === 'custom' ? this.custom : Number(this.selected)
      )
    );
  }

  setCustomDonate(amount) {
    this.selected = 'custom';
    if (!this.custom || amount === 0) {
      return false;
    }
    this.store.dispatch(new DonationActions.SetDonationAmount(this.custom));
  }

  setSelected($event, item) {
    $event.stopPropagation();
    $event.preventDefault();
    if ($event.keyCode === 13 || $event.keyCode === 32) {
      return this.onChange(item.value);
    }
  }

  onChange($event) {
    const amount = $event === 'custom' ? this.custom : Number($event);
    this.showAmountError = false;
    if (amount < this.min || amount > this.max) {
      this.showAmountError = true;
    }
    if ($event === 'custom') {
      GaClient.trackFieldAction('Amount-Money', this.custom);
    } else {
      GaClient.trackButtonClick('Amount-Money', amount);
    }

    this.store.dispatch(new DonationActions.SetDonationAmount(amount));
  }
}
